<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getQPR">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Control (QPR) Number</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Type number" v-model="search.qpr_number">
                  </div>
                  <div class="col-12 col-sm-3">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Issue Date</label>
                    <Datepicker 
                      v-model="search.issue_date" 
                      range
                      format="dd MMMM yyyy"
                      placeholder="Select date"
                      />
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Place</label>
                    <select v-model="search.find_place" class="form-select form-select-sm">
                        <option disabled selected>Find place</option>
                        <option value="internal">Internal</option>
                        <option value="customer">Customer</option>
                        <option value="internal_incoming">Internal Incoming</option>
                        <option value="internal_junbiki">Internal Junbiki</option>
                        <option value="internal_inprocess">Internal Inprocess</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Product Code</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Type product code" v-model="search.product_code">
                  </div>
                  <div class="col-12 col-sm-2">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Product Name</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Type product name" v-model="search.product_name">
                  </div>
                  <div class="col-12 col-sm-1 align-self-top pt-4">
                    <button type="submit" class="btn btn-primary mb-0 justify-content-center" style="width: 50px;" @click="resetOffset">
                      <i class="fa fa-search"></i>
                    </button>

                    <!-- Adding margin to create space -->
                    <button class="btn btn-primary mb-0 justify-content-center" style="width: 50px; margin-left: 5px;" @click="clearSearch">
                      <i class="fa fa-times-circle"></i>
                    </button>

                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-between">
                <div class="d-grip gap-2 d-flex">
                    <!-- <button class="btn btn-xs btn-outline-primary"><i class="fa fa-download"></i> Download</button> -->
                </div>
                <div class="d-flex">
                  <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                  <argon-pagination color="gradient-primary" size="sm">
                    <argon-pagination-item
                      @click="prevPage"
                      prev
                      :disabled="offset === 0 ? true : false" />
                    <argon-pagination-item
                      @click="nextPage"
                      next
                      :disabled="record_more === false ? true : false" />
                  </argon-pagination>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                    <thead>
                        <tr class="bg-light">
                            <!-- <th class="text-uppercase text-xxs font-weight-bolder ps-2 pt-3"><input type="checkbox" class="mb-0"/></th> -->
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Control Number</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Issue Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Deadline Date</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Find Place</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Product Code</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Product Name</th>
                            <th class="text-uppercase text-xxs font-weight-bolder ps-2">Drawback Classification</th>
                        </tr>
                    </thead>
                  <tbody>
                    <tr v-for="(qpr, i) in qpr_list" :key="i">
                      <!-- <td class="w-5">
                        <input type="checkbox" class="mb-0"/>
                      </td> -->
                      <td>
                        <router-link :to="'/qpr/' + qpr.id" class="text-xs text-primary font-weight-bold mb-0">
                            {{ qpr.name }}
                        </router-link>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ qpr.issue_date }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs text-danger">{{ qpr.deadline_date }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ qpr.find_place }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ qpr.product_code }}</p>
                      </td>
                      <td>
                          <p class="mb-0 text-xs">{{ qpr.product_name }}</p>
                      </td>
                      <td>
                          <argon-badge 
                            :variant="qpr.drawback_classification === 'FATAL' ? 'gradient' : ''" 
                            :color="qpr.drawback_classification === 'FATAL' ? 'danger' : 
                                    qpr.drawback_classification === 'HEAVY' ? 'warning' : 
                                    qpr.drawback_classification === 'LIGHT' ? 'secondary' : ''"
                            size="sm">{{ qpr.drawback_classification }}</argon-badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!qpr_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "qpr",
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonBadge,
    EmptyState,
    LoadingState
  },
  data() {
    return {
      search: {
          issue_date: null,
          find_place: null,
          product_code: null,
          product_name: null,
      },
      qpr_list: [],
      loading: false,
      total_data: 0,
      current_total_data: 0,
      record_more: false,
      page: 0,
      current_page: 0,
      offset: 0
    };
  },
  methods: {
    prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getQPR()
        }
      },
    nextPage() {
      if (this.record_more === true) {
        this.offset = this.offset + 10
        this.getQPR()
      }
    },
    getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
    getQPR() {
      this.loading = true
      this.qpr_list = []
      this.total_data = 0
      this.current_total_data = 0
      this.record_more = false
      this.current_page = 0
      let qpr_date = this.getDate(this.search.issue_date)
      this.axios
      .post(
        endpoint.QPR_LIST,
        {
          qpr_number: this.search.qpr_number,
          issue_date_start: qpr_date.length > 0 ? qpr_date[0] : null,
          issue_date_end: qpr_date.length > 1 ? qpr_date[1] : null,
          product_code: this.search.product_code,
          product_name: this.search.product_name,
          find_place: this.search.find_place,
          partner_id: localStorage.getItem('partner_id'),
          limit: 10,
          offset: this.offset
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then((response) => {
        if (response.data.response_code === "0000") {
          this.qpr_list = response.data.data;
          this.total_data = response.data.total_data
          this.current_total_data = response.data.total_data
          this.record_more = response.data.record_more
          this.current_page = response.data.current_page
          this.loading = false
        } else {
          if (response.data.response_code !== "4000"){
            this.$notify({
              type: 'error',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        }
      })
      .catch((e) => {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.response.data.message,
        });
        this.loading = false
      });
    },
    clearSearch(){
          this.search.issue_date = null;
          this.search.find_place = null;
          this.search.product_code = null;
          this.search.product_name = null;
    }
  },
  mounted() {
    this.getQPR()
  }
};
</script>

<style>

</style>